export const LinkedinAutomationsByLocation = `query LinkedinAutomationsByLocation($locationid: ID!, $pageNumber: Int!, $pageSize: Int!, $type: Int) {
  linkedinAutomationsByLocation(locationid: $locationid, pageNumber: $pageNumber, pageSize: $pageSize, type: $type) {
    count
    rows {
      automationid
      name
      starttime
      timezone
      contactcount
      totalactivecontact
      totalpausedcontact
      totalinactivecontact
      totalfailedcontact
      locationid
      businessid
      status
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
      error
      type
      createduser {
        userid
        firstname
        lastname
      }
    }
  }
}`;

export const CreateLinkedinAutomation = `mutation CreateLinkedinAutomation($name: String!, $accountid: String, $locationid: ID!, $businessid: ID!, $createdby: ID!, $starttime: String, $timezone: String, $status: Int, $automationsteps: [AutomationStepInput], $executiondays: [ExecutionDays!], $type: Int) {
  createLinkedinAutomation(name: $name, accountid: $accountid, locationid: $locationid, businessid: $businessid, createdby: $createdby, starttime: $starttime, timezone: $timezone, status: $status, automationsteps: $automationsteps, executiondays: $executiondays, type: $type) {
    automationid
    name
    linkedinautomationstep {
      automationstepid
      automationid
      sequence
      days
      hours
      minutes
      actiontype
      status
      isaddauthor
      title
      body
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
      attachments
    }
    linkedinautomationcontact {
      automationcontactid
      contactid
      automationstartdate
      automationid
      locationid
      businessid
      status
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
    }
    executiondays {
      days
      starttime
      endtime
    }
    starttime
    timezone
    contactcount
    totalactivecontact
    totalpausedcontact
    totalinactivecontact
    totalfailedcontact
    locationid
    businessid
    status
    type
    deleted
    accountid
    createdby
    updatedby
    createdAt
    updatedAt
    createduser {
      userid
    }
  }
}`;

export const LinkedinAutomationByAutomationId = `query LinkedinAutomation($automationid: ID!) {
  linkedinAutomation(automationid: $automationid) {
    automationid
    name
    linkedinautomationstep {
      automationstepid
      automationid
      sequence
      days
      hours
      minutes
      actiontype
      isaddauthor
      status
      title
      body
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
      attachments
    }
    executiondays {
      days
      starttime
      endtime
    }
    connectionlimit
    messagelimit
    commentprompt
    isautoreply
    website
    meetinglink
    linkedinautomationcontact {
      automationcontactid
      contactid
      automationstartdate
      automationid
      locationid
      businessid
      status
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
    }
    starttime
    timezone
    contactcount
    totalactivecontact
    totalpausedcontact
    totalinactivecontact
    totalfailedcontact
    locationid
    businessid
    status
    deleted
    accountid
    createdby
    updatedby
    createdAt
    updatedAt
  }
}`;

export const ReplicateLinkedinAutomation = `mutation ReplicateLinkedinAutomation($automationid: ID!, $createdby: ID!, $accountid: String) {
  replicateLinkedinAutomation(automationid: $automationid, createdby: $createdby, accountid: $accountid) {
    automationid
    name
    starttime
    timezone
    contactcount
    totalactivecontact
    totalpausedcontact
    totalinactivecontact
    totalfailedcontact
    locationid
    businessid
    status
    deleted
    accountid
    createdby
    updatedby
    createdAt
    updatedAt
  }
}`;

export const EditLinkedinAutomation = `mutation EditLinkedinAutomation($automationid: ID!, $locationid: ID!, $updatedby: ID!, $name: String, $starttime: String, $automationsteps: [AutomationStepInput], $timezone: String, $accountid: String, $businessid: ID, $status: Int, $executiondays: [ExecutionDays!], $connectionlimit: Int, $messagelimit: Int, $commentprompt: String, $website: String,$meetinglink: String, $isautoreply: Boolean) {
  editLinkedinAutomation(automationid: $automationid, locationid: $locationid, updatedby: $updatedby, name: $name, starttime: $starttime, automationsteps: $automationsteps, timezone: $timezone, accountid: $accountid, businessid: $businessid, status: $status, executiondays: $executiondays, connectionlimit: $connectionlimit, messagelimit: $messagelimit, commentprompt: $commentprompt, website: $website, meetinglink: $meetinglink, isautoreply: $isautoreply)
}`;

export const DeleteLinkedinAutomation = `mutation DeleteLinkedinAutomation($automationid: ID!) {
  deleteLinkedinAutomation(automationid: $automationid)
}`;

export const CreateAutomationStep = `mutation CreateAutomationStep($automationid: ID!, $actiontype: Int!, $title: String!, $locationid: ID!, $createdby: ID!, $sequence: Int, $days: Int, $hours: Int, $minutes: Int, $status: Int, $businessid: ID, $body: String, $attachments: String, $isaddauthor: Boolean) {
  createAutomationStep(automationid: $automationid, actiontype: $actiontype, title: $title, locationid: $locationid, createdby: $createdby, sequence: $sequence, days: $days, hours: $hours, minutes: $minutes, status: $status, businessid: $businessid, body: $body, attachments: $attachments, isaddauthor: $isaddauthor) {
    automationstepid
    automationid
    sequence
    days
    hours
    minutes
    actiontype
    status
    title
    body
    isaddauthor
    deleted
    createdby
    updatedby
    createdAt
    updatedAt
    attachments
  }
}`;

export const EditAutomationStep = `mutation EditAutomationStep($automationstepid: ID!, $automationid: ID!, $locationid: ID!, $updatedby: ID!, $sequence: Int, $days: Int, $hours: Int, $minutes: Int, $actiontype: Int, $status: Int, $title: String, $body: String, $businessid: ID, $attachments: String, $isaddauthor: Boolean) {
  editAutomationStep(automationstepid: $automationstepid, automationid: $automationid, locationid: $locationid, updatedby: $updatedby, sequence: $sequence, days: $days, hours: $hours, minutes: $minutes, actiontype: $actiontype, status: $status, title: $title, body: $body, businessid: $businessid, attachments: $attachments, isaddauthor: $isaddauthor)
}`;

export const DeleteAutomationStep = `mutation DeleteAutomationStep($automationstepid: ID!) {
  deleteAutomationStep(automationstepid: $automationstepid)
}`;

export const AutomationStep = `query AutomationStep($automationstepid: ID!) {
  automationStep(automationstepid: $automationstepid) {
    automationstepid
    automationid
    sequence
    days
    hours
    minutes
    actiontype
    status
    title
    body
    isaddauthor
    deleted
    createdby
    updatedby
    createdAt
    updatedAt
    attachments
  }
}`;

export const BulkCreateAutomationContacts = `mutation BulkCreateAutomationContacts($automationstartdate: String!, $automationid: ID!, $locationid: ID!, $createdby: ID!, $contactids: [ID!], $businessid: ID, $status: Int, $searchText: String, $advancedfilter: [AdvancedFilter!], $systemfilters: [SystemFiltersInput!], $filterid: ID, $selectiontype: Int) {
  bulkCreateAutomationContacts(automationstartdate: $automationstartdate, automationid: $automationid, locationid: $locationid, createdby: $createdby, contactids: $contactids, businessid: $businessid, status: $status, searchText: $searchText, advancedfilter: $advancedfilter, systemfilters: $systemfilters, filterid: $filterid, selectiontype: $selectiontype) {
    automationcontactid
    contactid
    automationstartdate
    automationid
    locationid
    businessid
    status
    deleted
    createdby
    updatedby
    createdAt
    updatedAt
  }
}`;

export const BulkUpdateAutomationContacts = `mutation BulkUpdateAutomationContacts($updatedby: ID!, $status: Int!, $automationid: ID!, $actiontype: Int! ) {
  bulkUpdateAutomationContacts(updatedby: $updatedby, status: $status, automationid: $automationid, actiontype: $actiontype)
}`;

export const EditAutomationContact = `mutation EditAutomationContact($automationcontactid: ID!, $updatedby: ID!, $contactid: ID, $automationstartdate: String, $automationid: ID, $locationid: ID, $businessid: ID, $status: Int, $isresume: Boolean) {
  editAutomationContact(automationcontactid: $automationcontactid, updatedby: $updatedby, contactid: $contactid, automationstartdate: $automationstartdate, automationid: $automationid, locationid: $locationid, businessid: $businessid, status: $status, isresume: $isresume)
}`;

export const AutomationReportByautomationid = `query AutomationReportByautomationid($automationid: ID!, $stepid: ID) {
  automationReportByautomationid(automationid: $automationid, stepid: $stepid) {
    automationid
    name
    steps {
      automationstepid
      automationid
      sequence
      days
      hours
      minutes
      actiontype
      status
      title
      body
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
    }
    contactlist {
      automationcontactid
      automationid
      contactid
      stepid
      completedate
      steps
      error
      locationid
      businessid
      status
      deleted
      createdby
      updatedby
      createdAt
      updatedAt
      contact {
        contactid
        firstname
        lastname
        primaryemail
        phonenumber
        linkedin
      }
      reportstatus
    }
    locationid
    status
    deleted
    createdby
    updatedby
    createdAt
    updatedAt
    timezone
    starttime
    totalcontact
    completedcount
    inprogresscount
    pausedcontactcount
    failedcontactcount
  }
}`;

export const CreateLinkedInAccount = `mutation CreateLinkedInAccount($email: String!, $password: String!, $businessid: ID!, $country: String) {
  createLinkedInAccount(email: $email, password: $password, businessid: $businessid, country: $country)
}`;

export const VerifyLinkedInAccount = `mutation VerifyLinkedInAccount($accountId: String!, $code: String!) {
  verifyLinkedInAccount(account_id: $accountId, code: $code)
}`;

export const ResendNotification = `mutation ResendNotification($accountId: String!) {
  resendNotification(account_id: $accountId)
}`;

export const LinkedinAccountByBusiness = `query LinkedinAccountByBusiness($locationid: ID!) {
  linkedinAccountByBusiness(locationid: $locationid) {
    id
    username
    account_id
    locationid
    businessid
    status
    email
    connectionlimit
    messagelimit
    viewprofilelimit
    followprofilelimit
    endorselimit
    likepostlimit
    commentlimit
    timezone
  }
}`;

export const DeleteLinkedInAccount = `mutation DeleteLinkedInAccount($accountId: String!) {
  deleteLinkedInAccount(account_id: $accountId)
}`;

export const UpdateAccountStatus = `mutation UpdateAccountStatus($locationid: ID!, $businessid: ID!, $createdby: ID!, $email: String!, $accountId: String!, $reconnect: Boolean, $timezone: String!) {
  updateAccountStatus(locationid: $locationid, businessid: $businessid, createdby: $createdby, email: $email, account_id: $accountId, reconnect: $reconnect, timezone: $timezone)
}`

export const CheckAccountStatus = `mutation CheckAccountStatus($accountId: String!) {
  checkAccountStatus(account_id: $accountId)
}`

export const UpdateAccountLimit = `mutation UpdateAccountLimit($account_id: String!, $connectionlimit: Int!, $messagelimit: Int!, $viewprofilelimit: Int!, $followprofilelimit: Int!, $likepostlimit: Int!, $commentlimit: Int!, $endorselimit: Int!, $timezone: String! ) {
  updateAccountLimit(account_id: $account_id, connectionlimit: $connectionlimit, messagelimit: $messagelimit, viewprofilelimit: $viewprofilelimit, followprofilelimit: $followprofilelimit, likepostlimit: $likepostlimit, commentlimit: $commentlimit, endorselimit: $endorselimit, timezone: $timezone)
}`

export const ImportLinkedInData = `mutation ImportLinkedInData($url: String!, $accountid: String!, $searchtype: Int!, $leadcount: Int, $locationid: ID!, $businessid: ID!, $createdby: ID!, $tags: [String!]) {
  importLinkedInData(url: $url, accountid: $accountid, searchtype: $searchtype, leadcount: $leadcount, locationid: $locationid, businessid: $businessid, createdby: $createdby, tags: $tags)
}`

export const AutomationReportCount = `query AutomationReportCount($accountid: ID, $automationid: ID, $startdate: String, $enddate: String) {
  automationReportCount(accountid: $accountid, automationid: $automationid, startdate: $startdate, enddate: $enddate) {
    connectioncount
    acceptedcount
    messagesentcount
    responsecount
  }
}`;

export const LinkedinAutomationsByAccount = `query LinkedinAutomationsByAccount($accountid: ID!, $pageNumber: Int!, $pageSize: Int!) {
  linkedinAutomationsByAccount(accountid: $accountid, pageNumber: $pageNumber, pageSize: $pageSize) {
    count
    rows {
      accountid
      automationid
      name
    }
  }
}`;

export const CreateLinkedinContacts = `mutation CreateLinkedinContacts($createdby: ID!, $locationid: ID!, $contactsData: [customerInput!], $businessid: ID) {
  createLinkedinContacts(createdby: $createdby, locationid: $locationid, contactsData: $contactsData, businessid: $businessid) {
    contactid
  }
}`;